var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4171_19314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.5H22.5C23.0523 5.5 23.5 5.94771 23.5 6.5V19C23.5 19.5523 23.0523 20 22.5 20H17.5M17.5 5.5H2C1.44772 5.5 1 5.94772 1 6.5V19C1 19.5523 1.44772 20 2 20H17.5M17.5 5.5V20M14 8H4.5C3.94772 8 3.5 8.44772 3.5 9V16.5C3.5 17.0523 3.94772 17.5 4.5 17.5H14C14.5523 17.5 15 17.0523 15 16.5V9C15 8.44772 14.5523 8 14 8Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 9,
    r: 1,
    transform: "rotate(90 20.6 9)",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6,
    cy: 13.49,
    r: 1,
    transform: "rotate(90 20.6 13.49)",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4171_19314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.881a7ec55d08f1f16bd48e0ddf3c3bf1.svg";
export { ForwardRef as ReactComponent };